/**
 * 按钮组件字段配置
 */
let config = [
  {
    'name': '按钮',
    'type': 'module-name'
  },
  {
    'key': 'property_data',
    'name': '属性',
    'type': 'custom',
    'content': [
      {
        'key': 'text',
        'name': '按钮文本',
        'type': 'text',
        'required': true
      },
      {
        'key': 'button_type',
        'name': '按钮类型',
        'type': 'select',
        'option-list': [
          {
            'label': '主要',
            'value': 'primary'
          },
          {
            'label': '成功',
            'value': 'success'
          },
          {
            'label': '警告',
            'value': 'warning'
          },
          {
            'label': '危险',
            'value': 'danger'
          },
          {
            'label': '信息',
            'value': 'info'
          },
          {
            'label': '默认',
            'value': 'default'
          }
        ]
      },
      {
        'key': 'size',
        'name': '按钮尺寸',
        'type': 'select',
        'option-list': [
          {
            'label': '默认',
            'value': 'medium'
          },
          {
            'label': '小型',
            'value': 'small'
          },
          {
            'label': '迷你',
            'value': 'mini'
          }
        ]
      },
      {
        'key': 'shape',
        'name': '按钮形状',
        'type': 'select',
        'option-list': [
          {
            'label': '默认',
            'value': 'default'
          },
          {
            'label': '圆角',
            'value': 'round'
          },
          {
            'label': '圆形',
            'value': 'circle'
          }
        ]
      },
      {
        'key': 'plain',
        'name': '朴素按钮',
        'type': 'radio-box',
        'radio-list': [
          {
            'value': true,
            'label': '是'
          },
          {
            'value': false,
            'label': '否'
          }
        ]
      },
      {
        'key': 'loading',
        'name': '加载状态',
        'type': 'radio-box',
        'radio-list': [
          {
            'value': true,
            'label': '是'
          },
          {
            'value': false,
            'label': '否'
          }
        ]
      },
      {
        'key': 'disabled',
        'name': '禁用状态',
        'type': 'radio-box',
        'radio-list': [
          {
            'value': true,
            'label': '是'
          },
          {
            'value': false,
            'label': '否'
          }
        ]
      },
      {
        'key': 'link',
        'name': '链接地址',
        'type': 'text'
      },
      {
        'key': 'open_type',
        'name': '打开方式',
        'type': 'select',
        'option-list': [
          {
            'label': '新窗口',
            'value': '_blank'
          },
          {
            'label': '当前窗口',
            'value': '_self'
          }
        ]
      },
      {
        'key': 'margin_top',
        'name': '上边距',
        'type': 'height',
      },
      {
        'key': 'margin_right',
        'name': '右边距',
        'type': 'height',
      },
      {
        'key': 'margin_bottom',
        'name': '下边距',
        'type': 'height',
      },
      {        
        'key': 'margin_left',
        'name': '左边距',
        'type': 'height',
      },
      {
        'key': 'alignment',
        'name': '对齐方式',
        'type': 'select',
        'option-list': [
          {
            'label': '居左',
            'value': 'left'
          },
          {
            'label': '居中',
            'value': 'center'
          },
          {
            'label': '居右',
            'value': 'right'
          }
        ]
      },
    ],
  },
];

export default config;